import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPortalFilledProfileIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M10.587 9.06829C12.0008 9.6366 13.3363 11.3154 13.963 13.3136C14.1062 13.771 13.7444 14.2668 13.1575 14.2669L2.84501 14.2693C2.25832 14.2694 1.89558 13.7737 2.03815 13.3153C2.65964 11.3192 3.98388 9.64414 5.41318 9.06946L10.587 9.06829Z",
			fill: "#33BF8D",
			stroke: "#008355",
			strokeWidth: .8,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.5 7.5V8.16309C10.4998 9.54359 9.38056 10.6631 8 10.6631C6.61944 10.6631 5.50024 9.54359 5.5 8.16309V7.5H10.5Z",
			fill: "white",
			stroke: "#008355"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 8.00033,
			cy: 5.33333,
			r: 3.83333,
			fill: "white",
			stroke: "#008355"
		})
	]
});
const ForwardRef = forwardRef(SvgPortalFilledProfileIcon);
const Memo = memo(ForwardRef);
export default Memo;
